import { render, staticRenderFns } from "./AestheticBeforeAfterMedia.vue?vue&type=template&id=3c85c67f&scoped=true"
import script from "./AestheticBeforeAfterMedia.vue?vue&type=script&lang=js"
export * from "./AestheticBeforeAfterMedia.vue?vue&type=script&lang=js"
import style0 from "./AestheticBeforeAfterMedia.vue?vue&type=style&index=0&id=3c85c67f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85c67f",
  null
  
)

export default component.exports